import HomeView from "./views/HomeView";
const App = () => {
  return <HomeView />;
};

export default App;
